import React from "react";

const Footer = () => (
	<footer className="bg-red-800 text-white py-4 text-center">
		<p>&copy; 2025 Fornido Development Company Limited</p>
	</footer>
);

export default Footer;
